import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { ProdutoLoteService } from 'src/app/services/produto-lote.service';
import { VendaItemLoteService } from 'src/app/services/venda-item-lote.service';
import { VendaItemModel } from 'src/app/dominio/venda-item-model';
import { ProdutoLoteModel } from 'src/app/dominio/produto-lote-model';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { TipoArquivo } from "../../models/enum";
import { ArquivoService } from "../../services/arquivo.service";
import { UtilitarioService } from "../../services/utilitario.service";
import { EnviarEmailModalComponent } from "../enviar-email-modal/enviar-email-modal.component";
import { MatDialog } from "@angular/material/dialog";

declare const $: any;

@Component({
  selector: "app-venda-item-lotes-modal",
  templateUrl: "./venda-item-lotes-modal.component.html",
  styleUrls: ["./venda-item-lotes-modal.component.scss"],
})
export class VendaItemLotesModalComponent implements OnInit {
  public idCupom: number;
  public somenteLeitura = false;
  public config: PerfectScrollbarConfigInterface = {};
  public itens: (VendaItemModel & { lotes?: ProdutoLoteModel[] })[] = [];

  constructor(
    public dialogRef: MatDialogRef<VendaItemLotesModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private vendaItemService: VendaItemLoteService,
    private produtoLoteService: ProdutoLoteService,
    private arquivoService: ArquivoService,
    private utilitarioService: UtilitarioService
  ) {
    this.idCupom = data.idCupom;
    this.somenteLeitura = data.somenteLeitura || false;
  }

  ngOnInit() {
    if (!this.idCupom) {
      this.notificacaoService.erro("ID do Cupom é obrigatório.");
      this.fechar();

      return;
    }

    this.carregarItens();
  }

  carregarItens() {
    this.carregandoService.mostra("carregandoItensVenda");
    this.vendaItemService.buscar(this.idCupom).subscribe(
      (res) => {
        this.itens = res.results;

        this.carregarLotesParaItens();
      },
      (erro) => {
        this.carregandoService.esconde("carregandoItensVenda");
        this.notificacaoService.erro(erro);
      }
    );
  }

  carregarLotesParaItens() {
    const produtosIds = Array.from(new Set(this.itens.map((i) => i.produto.idProduto)));
    const requests = produtosIds.map((idProduto) =>
      this.produtoLoteService.listar(idProduto).pipe(catchError(() => of({ results: [] })))
    );

    if (requests.length === 0) {
      this.carregandoService.esconde("carregandoItensVenda");

      return;
    }

    forkJoin(requests).subscribe((responses) => {
      const lotesPorProduto = {};

      produtosIds.forEach((id, index) => {
        lotesPorProduto[id] = responses[index].results;
      });

      this.itens.forEach((item) => {
        item.lotes = lotesPorProduto[item.produto.idProduto] || [];
      });

      this.carregandoService.esconde("carregandoItensVenda");
    });
  }

  salvar() {
    if (this.somenteLeitura) {
      return;
    }

    this.carregandoService.mostra("salvandoLotesItens");

    const requests = this.itens.map((item) =>
      this.vendaItemService.atualizar(this.idCupom, item.idVendaItem, { idLote: item.idLote })
    );

    if (requests.length === 0) {
      this.carregandoService.esconde("salvandoLotesItens");
      this.dialogRef.close();

      return;
    }

    forkJoin(requests).subscribe(
      () => {
        this.carregandoService.esconde("salvandoLotesItens");
        this.notificacaoService.sucesso("Lotes dos itens atualizados com sucesso.");
        this.dialogRef.close(true);
      },
      (erro) => {
        this.carregandoService.esconde("salvandoLotesItens");
        this.notificacaoService.erro(erro);
      }
    );
  }

  baixarAnexos() {
    this.carregandoService.mostra("baixarArquivos");
    this.vendaItemService.baixarTodos(this.idCupom).subscribe(
      (arq) => {
        this.utilitarioService.saveBlob(arq, "anexos.zip");
        this.carregandoService.esconde("baixarArquivos");
      },
      (erro) => {
        this.carregandoService.esconde("baixarArquivos");
        this.notificacaoService.erro(erro);
      }
    );
  }

  baixarAnexo(idVendaItem: number) {
    const item = this.itens.find((x) => x.idVendaItem === idVendaItem);

    if (item == null || item.produtoLote == null || item.produtoLote.anexo == null) {
      return;
    }

    const anexo = item.produtoLote.anexo;

    this.carregandoService.mostra("baixarArquivo");
    this.arquivoService.baixarArquivo(anexo.id, TipoArquivo.Anexo).subscribe(
      (arq) => {
        this.utilitarioService.saveBlob(arq, anexo.arquivo);
        this.carregandoService.esconde("baixarArquivo");
      },
      (erro) => {
        this.carregandoService.esconde("baixarArquivo");
        this.notificacaoService.erro(erro);
      }
    );
  }

  enviarEmail() {
    const largura = Number($("body").width());

    const dialogRef = this.dialog.open(EnviarEmailModalComponent, {
      width: largura > 1050 ? "1000px" : $("body").width().toString() + "px",
      data: {
        //para: ,
        assunto: `Lotes do pedido: ${this.idCupom}`,
        mensagem: `Prezado,\n\n Segue anexo os lotes e anexos do pedido ${this.idCupom}.`,
      },
      panelClass: "modal-card",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.carregandoService.mostra("enviarEmail");
        this.vendaItemService.enviarEmail(this.idCupom, result.para, result.assunto, result.mensagem).subscribe(
          () => {
            this.notificacaoService.sucesso("Envio de e-mail agendado com sucesso.");
            this.carregandoService.esconde("enviarEmail");
          },
          (erro) => {
            this.carregandoService.esconde("enviarEmail");
            this.notificacaoService.erro(erro);
          }
        );
      }
    });
  }

  fechar() {
    this.dialogRef.close();
  }
}
